import { FC, SVGProps } from 'react';

const UnassignAgent: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M17.8335 10.2637H14.4678"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.83362 16.6664C2.83362 14.9093 4.21999 12.7214 8.21594 12.7214C12.2111 12.7214 13.5975 14.8934 13.5975 16.6514"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.654 6.77131C11.654 8.67017 10.1149 10.2093 8.21595 10.2093C6.31785 10.2093 4.77869 8.67017 4.77869 6.77131C4.77869 4.87242 6.31785 3.33325 8.21595 3.33325C10.1149 3.33325 11.654 4.87242 11.654 6.77131Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UnassignAgent;
